import { useEffect, useState } from 'react';
import { DataService } from '../utils/dataService';

export type DocumentType = {
  id: number;
  code: string;
  name: string;
  enabled: boolean;
  validationDataType: string | null;
  validation: number | null;
  minimumValidation: number | null;
  digitVerification: boolean;
  isCompany: boolean;
  expirationDateRequired: boolean;
};

type UseDocumentTypesResult = {
  documentTypes: DocumentType[];
  loading: boolean;
  error: boolean;
};

const useDocumentTypes = (): UseDocumentTypesResult => {
  const [documentTypes, setDocumentTypes] = useState<DocumentType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const _dataService = new DataService();

    _dataService
      .post('/master-list/api/v1/document-type', { source: 'document' })
      .then((res) => {
        const enabled = (res.data?.data ?? []).filter((d: DocumentType) => d.enabled);
        setDocumentTypes(enabled);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return { documentTypes, loading, error };
};

export default useDocumentTypes;
